import {
  Avatar,
  Box,
  Container,
  Flex,
  Group,
  Menu,
  Text,
  createStyles,
  useMantineTheme,
  Badge,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
  IconAlbum,
  IconArrowLeft,
  IconArrowsTransferDown,
  IconBox,
  IconBoxModel,
  IconBuilding,
  IconBuildingBridge,
  IconCurrency,
  IconCurrencyRupee,
  IconDatabase,
  IconList,
  IconListDetails,
  IconLogout,
  IconMap,
  IconReport,
  IconStars,
  IconTag,
  IconTicket,
  IconTruck,
  IconTruckDelivery,
  IconTruckReturn,
  IconUser,
  IconUsers,
  IconBell,
  IconTools,
  IconClock,
  IconReceiptTax,
  IconLayoutDashboard,
  IconArchive,
  IconRefresh,
  IconReload,
  IconGitMerge,
} from "@tabler/icons";
import { header_bg_shade } from "config";
import { header_text_shade } from "config";
import { logo_name } from "config";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Collapse } from "@mantine/core";
import ShortcutKeys from "./Shortcut_keys";
import ShortcutHint from "./ShortcutHint";
import { IconChevronRight } from "@tabler/icons-react";
import { httpClient } from "../lib/axios";


const useStyles = createStyles(theme => ({
  link: {
    display: "block",
    lineHeight: 1,

    padding: "8px 12px",
    borderRadius: theme.radius.sm,
    textDecoration: "none",
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.brand[9],
    fontSize: theme.fontSizes.sm,
    fontWeight: 500,

    "&:hover": {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
    },
  },

  linkLabel: {
    marginRight: 5,
  },
}));

function AppHeader() {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const theme = useMantineTheme();
  const role = localStorage.getItem("role");
  const user = JSON.parse(localStorage.getItem("user"));
  const counter_name = user?.user?.counter_name;
  const location = useLocation();

  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    if (role !== "manager") return;

    const checkFeedbacks = () => {
      httpClient.get("area_feedback/")
        .then((res) => {
          if (res.data?.success && Array.isArray(res.data.data)) {
            const feedbacks = res.data.data;
            const lastSeenIdStr = localStorage.getItem("lastSeenAreaFeedbackId");
            
            if (feedbacks.length > 0) {
              const maxId = Math.max(...feedbacks.map(f => f.id));
              
              if (lastSeenIdStr === null) {
                // First time load: initialize lastSeenAreaFeedbackId with current max ID
                localStorage.setItem("lastSeenAreaFeedbackId", maxId.toString());
                setNotificationCount(0);
              } else {
                const lastSeenId = parseInt(lastSeenIdStr, 10);
                const newFeedbacks = feedbacks.filter(f => f.id > lastSeenId);
                setNotificationCount(newFeedbacks.length);
              }
            } else {
              if (lastSeenIdStr === null) {
                localStorage.setItem("lastSeenAreaFeedbackId", "0");
              }
              setNotificationCount(0);
            }
          }
        })
        .catch((err) => {
          console.error("Error fetching area feedback count", err);
        });
    };

    // Check immediately on mount
    checkFeedbacks();

    // Check periodically every 15 seconds
    const intervalId = setInterval(checkFeedbacks, 15000);

    const handleCheckNotifications = () => {
      checkFeedbacks();
    };

    window.addEventListener("checkNotifications", handleCheckNotifications);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("checkNotifications", handleCheckNotifications);
    };
  }, [role]);

  useEffect(() => {
    const handleAreaFeedbackSeen = () => {
      setNotificationCount(0);
    };

    window.addEventListener("areaFeedbackSeen", handleAreaFeedbackSeen);
    return () => {
      window.removeEventListener("areaFeedbackSeen", handleAreaFeedbackSeen);
    };
  }, []);

  let isMobileScreen = useMediaQuery("(max-width: 768px)");


  const [logo, setLogo] = useState('');
  useEffect(() => {
    import(`../static/images/${logo_name}`).then((module) => {
      setLogo(module.default);
    });
  }, [])

  const DropdownItem = ({ icon, label, open, onClick }) => (
  <Menu.Item
    icon={icon}
    onClick={onClick}
    closeMenuOnClick={false}
    rightSection={
      <IconChevronRight
        size={14}
        style={{
          transform: open ? "rotate(90deg)" : "rotate(0deg)",
          transition: "transform 200ms ease",
        }}
      />
    }
  >
    {label}
  </Menu.Item>
);
const [openSubMenu, setOpenSubMenu] = useState(null);

const closeAllSubMenus = () => {
  setOpenSubMenu(null);
};

  // RENDER STARTS HERE
  return (
    <>
      {/* 🔥 GLOBAL SHORTCUT KEYS */}
      <ShortcutKeys />

      {/* Top Header */}
      <div>
        <Box
          px={isMobileScreen ? 0 : 20}
          py={isMobileScreen ? 10 : 16}
          sx={theme => ({
            background: theme.colors.brand[header_bg_shade],
          })}
        >
          <Container fluid>
            <Flex justify={"space-between"} align="center" px={5}>
              <Flex align={"center"} justify={"center"}>
                {location.pathname === "/" ? (
                  <></>
                ) : (
                  <>
                    {isMobileScreen ? (
                      <IconArrowLeft
                        onClick={() => {
                          navigate(-1);
                        }}
                        color={theme.colors.brand[5]}
                      />
                    ) : (
                      <></>
                    )}
                  </>
                )}
                <Box h={"100%"}>
                  <Text
                    fw={800}
                    size={"lg"}
                    style={{
                      letterSpacing: "-1px",
                    }}
                  >
                    <Link
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                      }}
                      to={"/"}
                    >
                      <img
                        src={logo}
                        width={150}
                        height={49}
                        style={{
                          objectFit: "cover",
                        }}
                        alt="logo"
                      />
                    </Link>
                  </Text>
                </Box>
                <Text color={theme.colors.brand[header_text_shade]} size="xl" fw={500}>
                  - {role == "manager" ? "Admin" : counter_name}
                </Text>
              </Flex>

              <Flex align="center" gap="md">
                <Menu position="bottom-end" shadow="md" width={200} trigger="hover">
                  <Menu.Target>
                    <Flex align="center" gap="sm" style={{ cursor: "pointer" }}>
                      {/* Show the user's name */}
                      <Text fw={500}>
                        {user?.user?.first_name || user?.user?.username || "User"}
                      </Text>
                      <Avatar radius="xl" size={"30px"} />
                    </Flex>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Label> Settings </Menu.Label>
                    <Menu.Item icon={<IconUser size={14} />} component={Link} to="/manage-account">
                      Manage Account
                    </Menu.Item>
                    <Menu.Item
                      icon={<IconLogout size={14} />}
                      onClick={() => {
                        localStorage.clear();
                        navigate("/login");
                      }}
                    >
                      Logout
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>

                {role === "manager" && notificationCount > 0 && (
                  <Box
                    sx={{ position: "relative", cursor: "pointer", display: "flex", alignItems: "center" }}
                    onClick={() => navigate("/feedback?mode=area")}
                  >
                    <IconBell size={24} style={{ color: theme.colors.brand[header_text_shade] || "inherit" }} />
                    <Box
                      sx={(theme) => ({
                        position: "absolute",
                        top: -4,
                        right: -4,
                        backgroundColor: theme.colors.red[6],
                        color: "white",
                        borderRadius: "50%",
                        width: 16,
                        height: 16,
                        fontSize: 10,
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 0 0 2px white, 0 0 0 0 rgba(239, 68, 68, 0.7)",
                        animation: "pulse 1.5s infinite",
                        "@keyframes pulse": {
                          "0%": {
                            boxShadow: "0 0 0 2px white, 0 0 0 0 rgba(239, 68, 68, 0.7)",
                          },
                          "70%": {
                            boxShadow: "0 0 0 2px white, 0 0 0 6px rgba(239, 68, 68, 0)",
                          },
                          "100%": {
                            boxShadow: "0 0 0 2px white, 0 0 0 0 rgba(239, 68, 68, 0)",
                          },
                        },
                      })}
                    >
                      {notificationCount}
                    </Box>
                  </Box>
                )}
              </Flex>
            </Flex>
          </Container>
        </Box>
      </div>
      {/* Header */}
      <Box p={isMobileScreen ? 0 : 10} sx={theme => ({ background: "white" })}>
        <Container fluid>
          <Flex justify={isMobileScreen ? "space-between" : "flex-start"}>
            {role === "manager" && (
              <Menu position="bottom-start" shadow="md" width={200} trigger="hover" onClose={closeAllSubMenus}
>
                <Menu.Target>
                  <span className={classes.link}>
                    <Flex align={"center"}>
                      <IconDatabase size={"18"} /> <Text ml={5}>Master</Text>
                    </Flex>
                  </span>
                </Menu.Target>

                <Menu.Dropdown
                  sx={{
                    maxHeight: "calc(100vh - 140px)",
                    overflowY: "auto",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                  }}
                >
  <Menu.Label>Master</Menu.Label>

  <Menu.Item icon={<IconLayoutDashboard size={14} />} component={Link} to="/dash_board">
    Dashboard
  </Menu.Item>

  {/* Management */}
  <Box>
    <DropdownItem
      icon={<IconUsers size={14} />}
      label="Management"
      open={openSubMenu === "management"}
      onClick={() =>
        setOpenSubMenu((p) => (p === "management" ? null : "management"))
      }
    />

    <Collapse in={openSubMenu === "management"}>
      <Menu.Item pl={40} icon={<IconUsers size={14} />} component={Link} to="/users">
        Users
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconUser size={14} />} component={Link} to="/customers">
        Customers
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconMap size={14} />} component={Link} to="/address">
        Addresses
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconBuilding size={14} />} component={Link} to="/counters">
        Counters
      </Menu.Item>
    </Collapse>
  </Box>

  {/* Reviews */}
  <Box>
    <DropdownItem
      icon={<IconStars size={14} />}
      label="Reviews"
      open={openSubMenu === "reviews"}
      onClick={() =>
        setOpenSubMenu((p) => (p === "reviews" ? null : "reviews"))
      }
    />

    <Collapse in={openSubMenu === "reviews"}>
      <Menu.Item pl={40} icon={<IconStars size={14} />} component={Link} to="/reviews">
        Reviews
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconListDetails size={14} />} component={Link} to="/feedback">
        Feedback
      </Menu.Item>
    </Collapse>
  </Box>

  <Menu.Item icon={<IconTools size={14} />} component={Link} to="/website-maintenance">
    Maintenance
  </Menu.Item>

  {/* Products */}
  <Box>
    <DropdownItem
      icon={<IconBox size={14} />}
      label="Products"
      open={openSubMenu === "products"}
      onClick={() =>
        setOpenSubMenu((p) => (p === "products" ? null : "products"))
      }
    />

    <Collapse in={openSubMenu === "products"}>
      <Menu.Item pl={40} icon={<IconTag size={14} />} component={Link} to="/categories">
        Product Categories
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconBox size={14} />} component={Link} to="/products">
        Products
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconBoxModel size={14} />} component={Link} to="/products/merge-batches-counter">
        Merge Batches Counter
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconBoxModel size={14} />} component={Link} to="/products/merge-batches-warehouse">
        Merge Batches Warehouse
      </Menu.Item>
    </Collapse>
  </Box>

  <Menu.Item icon={<IconClock size={14} />} component={Link} to="/delivery-timevariant">
    Time Variant
  </Menu.Item>

  <Menu.Item icon={<IconAlbum size={14} />} component={Link} to="/banners">
    Banners
  </Menu.Item>

  {/* Cities */}
  <Box>
    <DropdownItem
      icon={<IconBuildingBridge size={14} />}
      label="Cities"
      open={openSubMenu === "cities"}
      onClick={() =>
        setOpenSubMenu((p) => (p === "cities" ? null : "cities"))
      }
    />

    <Collapse in={openSubMenu === "cities"}>
      <Menu.Item pl={40} icon={<IconBuildingBridge size={14} />} component={Link} to="/city-groups">
        City Groups
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconBuilding size={14} />} component={Link} to="/cities">
        Cities
      </Menu.Item>
    </Collapse>
  </Box>

  {/* Coupons */}
  <Box>
    <DropdownItem
      icon={<IconTicket size={14} />}
      label="Coupons"
      open={openSubMenu === "coupons"}
      onClick={() =>
        setOpenSubMenu((p) => (p === "coupons" ? null : "coupons"))
      }
    />

    <Collapse in={openSubMenu === "coupons"}>
      <Menu.Item pl={40} icon={<IconTools size={14} />} component={Link} to="/couponadmin">
        Coupon Admin
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconTicket size={14} />} component={Link} to="/coupons">
        Promotion Coupons
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconTicket size={14} />} component={Link} to="/yearlycoupon">
        Yearly Coupons
      </Menu.Item>
      <Menu.Item pl={40} icon={<IconUsers size={14} />} component={Link} to="/referralcoupons">
        Referral Coupons
      </Menu.Item>
      
    </Collapse>
  </Box>
</Menu.Dropdown>


              </Menu>
            )}

            {role !== "delivery" && (
              <>
                <Menu position="bottom-start" shadow="md" width={200} trigger="hover">
                  <Menu.Target>
                    <span className={classes.link}>
                      <Flex align={"center"}>
                        <IconBox size={"18"} /> <Text ml={5}>Inventory</Text>
                      </Flex>
                    </span>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Label> Inventory </Menu.Label>
                    <Menu.Item icon={<IconList size={14} />} component={Link} to="/stock-list" rightSection={<ShortcutHint label="Ctrl+L" />}>
                      Stock List
                    </Menu.Item>
                    <Menu.Item icon={<IconListDetails size={14} />} component={Link} to="/batch-merge-approvals">
                      Batch Merge Approvals
                    </Menu.Item>
                    <Menu.Item icon={<IconTruck size={14} />} component={Link} to="/stock-transfer" rightSection={<ShortcutHint label="Ctrl+S" />} >
                      Stock Transfer
                    </Menu.Item>
                    <Menu.Item icon={<IconTruckDelivery size={14} />} component={Link} to="/stock-received">
                      Stock Received
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
                <Menu position="bottom-start" shadow="md" width={200} trigger="hover">
                  <Menu.Target>
                    <span className={classes.link}>
                      <Flex align={"center"}>
                        <IconArrowsTransferDown size={"18"} /> <Text ml={5}>Transactions</Text>
                      </Flex>
                    </span>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Label> Transactions</Menu.Label>
                    <Menu.Item
                      icon={<IconCurrencyRupee size={14} />}
                      component={Link}
                      to="/invoices"
                      rightSection={<ShortcutHint label="Ctrl+I" />}
                    >
                      Invoices
                    </Menu.Item>
                    {/* <Menu.Item
                        icon={<IconCurrency size={14} />}
                        component={Link}
                        to="/warehouse-invoices"
                      >
                        Warehouse Invoices
                      </Menu.Item> */}
                    <Menu.Item icon={<IconBoxModel size={14} />} component={Link} to="/orders" rightSection={<ShortcutHint label="Ctrl+O" />}>
                      Orders
                    </Menu.Item>
                    {/* <Menu.Item icon={<IconTruckReturn size={14} />} component={Link} to="/returns" >
                      Returns
                    </Menu.Item> */}
                    <Menu.Item icon={<IconTruckReturn size={14} />} component={Link} to="/sales-return" rightSection={<ShortcutHint label="Ctrl+R" />}>
                      Sales Return
                    </Menu.Item>
                    <Menu.Item
                      icon={<IconTruckReturn size={14} />}
                      component={Link}
                      to="/payment-receipt"
                      rightSection={<ShortcutHint label="Ctrl+P" />}
                    >
                      Payment Receipt
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
                <Menu position="bottom-start" shadow="md" width={220} trigger="hover">
                  <Menu.Target>
                    <span className={classes.link}>
                      <Flex align={"center"}>
                        <IconReport size={"18"} /> <Text ml={5}>Reports</Text>
                      </Flex>
                    </span>
                  </Menu.Target>

                  <Menu.Dropdown
                    sx={{
                      maxHeight: "calc(100vh - 140px)",
                      overflowY: "auto",
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                      msOverflowStyle: "none",
                      scrollbarWidth: "none",
                    }}
                  >
                    <Menu.Label>Reports</Menu.Label>

                    <Menu.Item
                      icon={<IconReport size={14} />}
                      component={Link}
                      to="/sales-report"
                    >
                      Cut-off Collection Report
                    </Menu.Item>
                    <Menu.Item
                      icon={<IconReport size={14} />}
                      component={Link}
                      to="/replacements-report"
                    >
                      Replacements Report
                    </Menu.Item>
                    <Menu.Item
                      icon={<IconArchive size={14} />}
                      component={Link}
                      to="/holdstock-report"
                    >
                      Hold Stock Report
                    </Menu.Item>

                    <Menu.Item
                      icon={<IconRefresh  size={14} />}
                      component={Link}
                      to="/stocktransfer-report"
                    >
                      Stock Transfer Report
                    </Menu.Item>

                    <Menu.Item
                      icon={<IconTruckDelivery size={14} />}
                      component={Link}
                      to="/delivery-report"
                    >
                      Delivery Report
                    </Menu.Item>

                    {role === "manager" && (
                      <Menu.Item
                        icon={<IconBell size={14} />}
                        component={Link}
                        to="/notify-report"
                      >
                        Notify Report
                      </Menu.Item>
                    )}

                    <Menu.Item
                      icon={<IconTruckDelivery size={14} />}
                      component={Link}
                      to="/orderstatus-report"
                    >
                      Order Status Report
                    </Menu.Item>

                    {role === "manager" && (
                      <Menu.Item
                        icon={<IconTools size={14} />}
                        component={Link}
                        to="/maintenance-report"
                      >
                        Maintenance Report
                      </Menu.Item>
                    )}
                    {role === "manager" && (
                      <Menu.Item
                        icon={<IconGitMerge size={14} />}
                        component={Link}
                        to="/warehouse-merge-report"
                      >
                        Warehouse Merge Report
                      </Menu.Item>
                    )}
                    <Menu.Item
                      icon={<IconReceiptTax size={14} />}
                      component={Link}
                      to="/itemwisesummary-report"
                    >
                      Item Wise Report
                    </Menu.Item>
                    {role === "manager" && (
                      <Menu.Item
                        icon={<IconReport size={14} />}
                        component={Link}
                        to="/stock-error-report"
                      >
                        Stock Error Report
                      </Menu.Item>
                    )}
                  </Menu.Dropdown>
                </Menu>

              </>
            )}

            {/* Deliveries */}
            {role === "delivery" && (
              <Menu position="bottom-start" shadow="md" width={200} trigger="hover">
                <Menu.Target>
                  <span className={classes.link}>
                    <Flex align={"center"}>
                      <IconTruck size={"18"} /> <Text ml={5}>Delivery</Text>
                    </Flex>
                  </span>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Label> Delivery </Menu.Label>
                  <Menu.Item
                    icon={<IconTruckDelivery size={14} />}
                    component={Link}
                    to="/deliveries"
                  >
                    All Deliveries
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            )}
            {/* <AppSpotlight /> */}
          </Flex>
        </Container>
      </Box>
    </>
  );
}

export default AppHeader;
